<div class="source-group">
  <h3 class="source-heading">Social Sites</h3>
  <vf-vsource-option
    *ngFor="let source of socialSites"
    [source]="source"
    (sourceSelected)="updateValues($event, source.sourceId)"
    [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
    [disabled]="disabledSources.indexOf(source.sourceId) > -1"
  ></vf-vsource-option>
  <h3 class="source-heading">Search Sites</h3>
  <vf-vsource-option
    *ngFor="let source of searchEngines"
    [source]="source"
    (sourceSelected)="updateValues($event, source.sourceId)"
    [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
    [disabled]="disabledSources.indexOf(source.sourceId) > -1"
  ></vf-vsource-option>
  <ng-container *ngIf="enableInternetDataProviders">
    <h3 class="source-heading">Data Providers</h3>
    <vf-vsource-option
      *ngFor="let source of internetDataProviders"
      [source]="source"
      (sourceSelected)="updateValues($event, source.sourceId)"
      [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
      [disabled]="disabledSources.indexOf(source.sourceId) > -1"
    ></vf-vsource-option>
  </ng-container>
  <ng-container *ngIf="columns === 2">
    <h3 class="source-heading">Review Sites</h3>
    <vf-vsource-option
      *ngFor="let source of reviewSites"
      [source]="source"
      (sourceSelected)="updateValues($event, source.sourceId)"
      [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
      [disabled]="disabledSources.indexOf(source.sourceId) > -1"
    ></vf-vsource-option>
  </ng-container>
</div>
<div class="source-group" *ngIf="columns === 3">
  <h3 class="source-heading">Review Sites</h3>
  <vf-vsource-option
    *ngFor="let source of reviewSites"
    [source]="source"
    (sourceSelected)="updateValues($event, source.sourceId)"
    [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
    [disabled]="disabledSources.indexOf(source.sourceId) > -1"
  ></vf-vsource-option>
</div>
<div class="source-group">
  <h3 class="source-heading">Directory Sites</h3>
  <vf-vsource-option
    *ngFor="let source of directorySites"
    [source]="source"
    (sourceSelected)="updateValues($event, source.sourceId)"
    [initialChecked]="sourceData.value.indexOf(source.sourceId) > -1"
    [disabled]="disabledSources.indexOf(source.sourceId) > -1"
  ></vf-vsource-option>
</div>
